import { render, staticRenderFns } from "./companySn.vue?vue&type=template&id=3fc60f14&scoped=true&"
import script from "./companySn.vue?vue&type=script&lang=js&"
export * from "./companySn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc60f14",
  null
  
)

export default component.exports